import { Dispatch } from "redux";

import api from "@helpers/api";

import { CommitteeStateAction } from "@reducers/types/procurements/committee-state";

import {
  GET_COMMITTEE,
  GET_SINGLE_COMMITTEE,
  CREATE_COMMITTEE,
  UPDATE_COMMITTEE,
  DELETE_COMMITTEE,
} from "./types";
import { CommitteeCreateType } from "@type/procurements/committee";
import {
  fetchCommittee,
  fetchCommitteeById,
  createCommittee,
  updateCommittee,
  deleteCommittee,
} from "@api/procurements/committee";

export const committeeFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<CommitteeStateAction>) => {
    dispatch({ type: GET_COMMITTEE.LOADING, payload: true });

    try {
      const res = await fetchCommittee(query);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_COMMITTEE.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_COMMITTEE.ERROR, payload: err });
    }
  };

export const committeeByIdFetchActionHandler =
  (id: string | number) => async (dispatch: Dispatch<CommitteeStateAction>) => {
    dispatch({ type: GET_SINGLE_COMMITTEE.LOADING, payload: true });

    try {
      const res = await fetchCommitteeById(id);

      dispatch({
        type: GET_SINGLE_COMMITTEE.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_COMMITTEE.ERROR, payload: err });
    }
  };

export const committeeCreateActionHandler =
  (data: CommitteeCreateType) =>
  async (dispatch: Dispatch<CommitteeStateAction>) => {
    dispatch({ type: CREATE_COMMITTEE.LOADING, payload: true });

    try {
      const res = await createCommittee(data);

      dispatch({ type: CREATE_COMMITTEE.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_COMMITTEE.ERROR, payload: err });
    }
  };

export const committeeUpdateActionHandler =
  (id: string | number, data: CommitteeCreateType) =>
  async (dispatch: Dispatch<CommitteeStateAction>) => {
    dispatch({ type: UPDATE_COMMITTEE.LOADING, payload: true });

    try {
      const res = await updateCommittee(id, data);

      dispatch({
        type: UPDATE_COMMITTEE.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: UPDATE_COMMITTEE.ERROR, payload: err });
    }
  };

export const committeeDeleteActionHandler =
  (id: string | number) => async (dispatch: Dispatch<CommitteeStateAction>) => {
    dispatch({ type: DELETE_COMMITTEE.LOADING, payload: true });

    try {
      const res = await deleteCommittee(id);

      dispatch({ type: DELETE_COMMITTEE.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: DELETE_COMMITTEE.ERROR, payload: err });
    }
  };
